import * as React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { attachLeftPanelSearchWidget } from '../controller/esriMapController'

export default function CustomSearchBar() {
  const { mapLoaded } = useSelector((state) => state.appSlice)
  const searchRef = React.useRef(null)
  React.useEffect(() => {
    if (searchRef.current && mapLoaded) {
      attachLeftPanelSearchWidget(searchRef.current)
    }
  }, [searchRef, mapLoaded])
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: 400,
        height: '36px',
        borderRadius: '20px',
        backgroundColor: '#E4E7EB',
        boxShadow: 'none'
      }}
      className="searchBar"
    >
      <Box
        sx={{ width: '400px !important', borderRadius: '20px !important' }}
        ref={searchRef}
      />
    </Box>
  )
}
